import { State } from "../state/state";
// import { Utils } from "../../../utils";

// Convert server data to User Interface friendly data
export const fromServer = (
  data: State.AlertRecentServer
): State.AlertRecent => {
  let date = new Date(data.when * 1000);
  return Object.assign({}, data, {
    when: `${date.toLocaleDateString()} ${date.toLocaleTimeString()}`
  });
};
